import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { filterCategories } from 'src/areas/landing-page/filter-categories';
import { Product, TrendingProductRecommendationsFragment } from 'src/types';
import ExpandableProductCardGrid from '../expandable-product-card-grid';
import { TRENDING_PRODUCT_CLICK } from 'src/globals/helpers/navigation-action';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = {
  trendingProducts?: Recommendations['trendingProducts'];
};

type Recommendations = NonNullable<
  TrendingProductRecommendationsFragment['trendingProductRecommendations']
>;

const TrendingProducts: React.FC<Props> = props => {
  const { trendingProducts = { nodes: [] } } = props;
  const { t } = useContext(AppContext);

  if (
    !(trendingProducts && trendingProducts.nodes) ||
    !trendingProducts.nodes.length
  ) {
    return null;
  }

  const trendingProductsItems = filterCategories(
    trendingProducts.nodes as Product[]
  );

  const trackHeaderClick = (data: { link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.TRENDING_PRODUCTS_HEADER,
      nextPage: data.link,
    });
  };

  const trackProductCardClick = (data: { index: number; link: string }) => {
    trackInternalNavigationClick({
      scope: InternalNavigationScope.TRENDING_PRODUCTS_PRODUCT_CARD,
      nextPage: data.link,
      index: data.index,
    });
  };

  return (
    <ExpandableProductCardGrid
      products={trendingProductsItems}
      title={t('landing', 'trending-products.title')}
      shouldLazyLoadImages
      productNavigationAction={TRENDING_PRODUCT_CLICK}
      onHeaderLinkClick={trackHeaderClick}
      onProductCardClick={trackProductCardClick}
    />
  );
};

export default TrendingProducts;
